import baseSymbols from './symbolsData/all';
import baseCategories from './symbolsData/categories';

export const symbols = baseSymbols;

export const categories = baseCategories;

export const symbolsByCategory = symbols;
